import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";

import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Input from "material-ui/Input";
import { FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from 'material-ui/Radio';
import Checkbox from "material-ui/Checkbox";
import Switch from "material-ui/Switch";
import DatePicker from "react-datepicker";

import Wrapper from "../common/Wrapper";
import Header from "../common/Header";
import ArrowToolTip from "../common/ArrowToolTip";
import Loader from "../Parts/Loader";
import Add from "../Icons/Add";
import Cancel from "../Icons/Cancel";
import HelpIcon from "../Icons/HelpIcon";
import CancelCircle from "../Icons/CancelCircle";

import SendLetterHeader from "./SendLetterHeader";
import InfoDialog from "./dialogs/InfoDialog";
import InfoBox from "./dialogs/InfoBox";
import EditSenderDialog from "../AccountSetting/Basic/EditSenderDialog";
import EditOrderContactDialog from "../AccountSetting/Basic/EditOrderContactDialog";
import EditRecipientDialog from "./dialogs/EditRecipientDialog";
import PlanDialog from "./dialogs/PlanDialog";
import NotificationBar from "../Parts/NotificationBar.jsx";
import ConfirmOrderDialog from "./dialogs/ConfirmOrderDialog";
import ConfirmFollowCallDialog from "./dialogs/ConfirmFollowCallDialog";
import SelectSenderDialog from "./dialogs/SelectSenderDialog";
import LetterFileUploadDialog from "./dialogs/LetterFileUploadDialog";
import { DialogType } from "../../constants/ComponentTypes";
import { ADD_ORDER_CONTACT, HOLIDAYS_JP } from "../../constants/Constants";
import { getMinBusinessDaysUntilShippingSchedule, getMaxBusinessDaysUntilShippingSchedule, getAddBusinessDaysUntilShippingSchedule, addBusinessDays } from "../../utils/sendLetterUtils";
import { getWordFileContent } from "../../utils/fileUtils";
import {
  formatPostcode,
  stripPostcode,
  addCommas,
  isWeekday,
  formatName,
} from "../../utils/utils";
import { isKLFollowCall } from "../../utils/userUtils";
import { isEnableUploadAdditionalFile, isEnableFollowCallHouseList } from "../../utils/userOptionUtils";
import { isEnabledSendLetter } from "../../utils/planUtils";
import {
  validateSender,
  validateAddressSendLetter,
  isUrl,
} from "../../utils/validator";
import {
  MAX_TRACKING_URL_LENGTH,
} from "../../constants/Constants";
import moment from "moment";
import * as errMessages from "../../constants/ErrorMessages";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
  },

  main: {
    background: "#F4F6F9",
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
  },

  header: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    backgroundColor: "white",
    borderBottom: "1px solid  #D8DBDF",
    bottom: 0,
    zIndex: 10,
    position: 'fixed',
  },

  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    width: "100%",
    boxSizing: "border-box",
    overflow: "scroll",
    padding: "30px 30px 80px",
  },

  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: "50px",
  },

  titleHeading: {
    color: "#181819",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "13px",
  },

  desc: {
    fontSize: "12px",
    padding: "15px 0",
    width: "100%",
    boxSizing: "border-box",
  },

  titleDesc: {
    color: "#5A5B62",
    fontSize: "14px",
  },

  linkBtn: {
    textDecoration: "underline",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: "rgba(90, 91, 98, 0.2)",
    },
  },

  linkBtn2: {
    cursor: "pointer",
    color: "#1A65FF",
    marginLeft: "15px",
    fontWeight: "normal",

    "&:hover": {
      background: "rgba(243, 247, 255, .2)",
    },
  },

  link: {
    color: "#181819",
    display: "block",
    "&:hover": {
      backgroundColor: "rgba(90, 91, 98, 0.2)",
    },
  },

  linkContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px",
    width: "215px",
    fontSize: "12px",
  },

  cardContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
  },

  card: {
    width: "500px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #E7E9EB",
    borderRadius: "12px",
    opacity: 1,
    padding: "24px 48px 40px 48px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },

  img: {
    width: "234px",
  },

  sectionHead: {
    width: "100%",
    borderBottom: "1px solid #E7E9EB",
    margin: "25px 0px 10px 0px",
    padding: "10px 0px",
    boxSizing: "border-box",
    fontSize: "13px",
    fontWeight: "bold",
    color: "#181819",
    display: "flex",
    alignItems: "center",
  },

  sectionRightHead: {
    width: "100%",
    borderBottom: "1px solid #E7E9EB",
    margin: "30px 0px 20px 0px",
    padding: "10px 0px",
    boxSizing: "border-box",
    fontSize: "13px",
    fontWeight: "bold",
    color: "#181819",
    display: "flex",
    alignItems: "center",
  },

  leftCardText: {
    wordBreak: "break-word"
  },

  leftCardToggleText: {
    wordBreak: "break-word"
  },

  box: {
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    boxSizing: "border-box",
    position: "relative",
  },

  btn: {
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    borderRadius: "2px",
  },

  btnGrey: {
    padding: "5px 0px",
    color: "#71737B",
  },

  btnSelect: {
    backgroundColor: "#transparent",
    color: "#5A5B62",
    padding: "2px",
    textDecoration: "underline",
    fontSize: "14px",
  },

  btnBlue: {
    padding: "5px 0px",
    color: "#1A65FF",
  },

  btnBlueSolid: {
    border: "1px solid #1A65FF",
    color: "#1A65FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "48px",
    fontSize: "16px",
    padding: "0px 40px",
    "&:hover": {
      backgroundColor: "#1A65FF",
      color: "#FFFFFF",
    },
  },

  preview: {
    width: "300px",
    boxShadow: "0px 3px 6px #00000029",
    margin: "auto",
  },

  notification: {
    height: "40px",
    backgroundColor: "#FFF3C6",
    color: "#181819",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: "bold",
  },

  qrCodeContainer: {
    boxSizing: " border-box",
  },

  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    marginTop: "12px",
  },

  filename: {
    marginRight: "10px",
    maxWidth: "90%",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  datePicker: {
    position: "absolute",
    right: "0",
    transform: "translate(90%, -110%)",
    zIndex: 1,
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },

  errorMessageRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "2px",
  },

  formControlLabel: {
    margin: 0,
  },

  switchBase: {
    height: "unset",
  },

  checkboxContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },

  fileContainer: {
    border: '1px solid #D9DBDF',
    borderRadius: '2px',
    width: '100%',
    display: "flex",
    alignItems: "center",
    boxSizing: " border-box",
  },

  fileType: {
    background: '#1A65FF',
    borderRight: '1px solid #D9DBDF',
    borderRadius: "2px 0px 0px 2px",
    minWidth: '46px',
    height: '45px',
    color: '#FFFFFF',
    textAlign: 'center',
    display: 'grid',
    alignItems: 'center',
  },

  fileInfo: {
    padding: "0 10px",
    display: "flex",
    width: "88.5%",
    justifyContent: "space-between",
    boxSizing: " border-box",
  },

});

class SendLetter extends React.Component {
  state = {
    to: {
      post_code: "",
      address: "",
      company_name: "",
      name: "",
      honorific: "",
      branch: "",
      suffix: "様",
    },
    from: {
      id: "",
      post_code: "",
      address: "",
      company_name: "",
      name: "",
      position: "",
      branch: "",
    },
    tracking_url: "",
    shintenMarkFlag: true,
    registeredLetterFlag: false,
    originalLetterFormatFlag: false,
    followCallFlag: false,
    showInfoDialog: false,
    showEditSenderDialog: false,
    showEditRecipientDialog: false,
    showNotification: false,
    showShippingAtNotification: true,
    showPlanDialog: false,
    showConfirmOrderDialog: false,
    showConfirmFollowCallDialog: false,
    showSelectSenderDialog: false,
    showLetterFileUploadDialog: false,
    showLetterAdditionalFileUploadDialog: false,
    showCalendar: false,
    showCreateOrderContactDialog: false,
    shippingScheduledAt: moment(),
    orderScheduledAt: moment(),
    showOrderCalendar: false,
    notUseQrCode: false,
    file: null,
    additionalFile: null,
    usePastLetterOrderForFile: null,
    usePastLetterOrderForAdditionalFile: null,
    isMulti: false,
    selectCount: 0,
    order_contact_id: -1,
    salesforce_sync_flag: false,
    showSendLetterInfoBox:
      this.props.cookies.get("showSendLetterInfoBox") === "0"
        ? false
        : this.props.showSendLetterInfoBox,
  };

  setMultiCountStateAndFetchData = (routerState) => {
    let targetId = null;
    let count = 0;
    let fetchFunc;
    if (routerState.hasOwnProperty("relocation_personnel_id")) {
      targetId = routerState.relocation_personnel_id;
      fetchFunc = this.props.getExecutiveListById;
    } else if (routerState.hasOwnProperty("address_id")) {
      targetId = routerState.address_id;
      fetchFunc = this.props.getAddressById;
    } else if (routerState.hasOwnProperty("query")) {
      targetId = routerState.ids[0];
      count = routerState.count;
      fetchFunc = routerState.isExe
        ? this.props.getExecutiveListById
        : this.props.getAddressById;
    } else {
      return this.displayNotification(
        `予期せぬエラーが発生しました。管理者へお問い合わせください。`, 'error'
      );
    }

    const multiCount = 2;
    this.setState({
      isMulti: count >= multiCount,
      selectCount: count,
    });

    fetchFunc(targetId);
  };

  componentDidMount() {
    if (this.props.routerInfo && this.props.routerInfo.state) {
      const minBusinessDays = getMinBusinessDaysUntilShippingSchedule();
      const maxBusinessDays = getMaxBusinessDaysUntilShippingSchedule((this.props.routerInfo.state.count) ? this.props.routerInfo.state.count : 1);
      this.displayNotification(
        `本日を含めて${minBusinessDays}営業日後から${maxBusinessDays}営業日後目安に発送されます。また注文状況や注文通数によっては${maxBusinessDays}営業日以上かかる場合があります。`, 'success'
      );

      this.setMultiCountStateAndFetchData(this.props.routerInfo.state);
    } else {
      this.props.goTo("/executive-list");
    }
    this.props.getUserInfo();
    this.props.getSenders();
    this.props.getOrderContacts();
    this.props.getSalesforceConfig();

    if (this.props.user !== null && this.props.senders.length > 0) {
      this.populateStateFromLocalStorage(this.props);
    }

    this.setState({
      shippingScheduledAt: this.calcShippingScheduledDate(),
    });
  }

  componentWillReceiveProps(nextProps) {
    const isExe = nextProps.routerInfo.state
      ? nextProps.routerInfo.state.isExe
      : true;

    if (isExe) {
      // stateのtoはUIで編集できる箇所なので、API実行時に毎回更新されないようにする
      if (!!nextProps.executiveListItem && this.props.executiveListItem !== nextProps.executiveListItem) {
        let { post_code, address, company_name, name, honorific } =
          nextProps.executiveListItem;
        this.setState({
          to: {
            post_code,
            address,
            company_name,
            name,
            honorific,
            suffix: "様",
          },
        });
      }
    } else {
      // stateのtoはUIで編集できる箇所なので、API実行時に毎回更新されないようにする
      if (!!nextProps.addressItem && this.props.addressItem !== nextProps.addressItem) {
        let { post_code, address, company, name, position, branch, honorific } =
          nextProps.addressItem;
        this.setState({
          to: {
            post_code,
            address,
            company_name: company,
            name,
            honorific: position,
            branch,
            suffix: honorific,
          },
        });
      }
    }

    if (this.props.sender.id !== nextProps.sender.id) {
      this.handleSelectSender(nextProps.sender);
    }

    if (
      this.props.isLoadingOrderContacts &&
      !nextProps.isLoadingOrderContacts
    ) {
      if (nextProps.orderContacts.length > 0) {
        this.setState({
          order_contact_id: nextProps.orderContacts[0].id,
        });
      }
    }

    if (
      this.props.orderContact.id !== nextProps.orderContact.id &&
      nextProps.orderContact.id !== undefined
    ) {
      this.setState({
        order_contact_id: nextProps.orderContact.id,
      });
    }

    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    if (this.props.isCheckOK === true && nextProps.isCheckOK === false) {
      this.displayNotification(nextProps.checkMessage, "green");
    }

    if (nextProps.user !== null && nextProps.senders.length > 0) {
      if (!this.state.tracking_url && !this.state.from.id) {
        this.populateStateFromLocalStorage(nextProps);
      }
    }

    this.setState({
      showSendLetterInfoBox:
        nextProps.cookies.get("showSendLetterInfoBox") === "0"
          ? false
          : nextProps.showSendLetterInfoBox,
    });
  }

  /******** toggle functions *******/
  toggleInfoDialog = () => {
    this.setState({ showInfoDialog: !this.state.showInfoDialog });
  };

  toggleEditSenderDialog = () => {
    this.setState({
      showEditSenderDialog: !this.state.showEditSenderDialog,
      showSelectSenderDialog: false,
    });
  };

  toggleSelectSenderDialog = () => {
    this.setState({
      showSelectSenderDialog: !this.state.showSelectSenderDialog,
    });
  };

  toggleCreateOrderContactDialog = () => {
    this.setState({
      showCreateOrderContactDialog: !this.state.showCreateOrderContactDialog,
    });
  };

  toggleEditRecipientDialog = () => {
    this.setState({
      showEditRecipientDialog: !this.state.showEditRecipientDialog,
    });
  };

  togglePlanDialog = () => {
    this.setState({ showPlanDialog: !this.state.showPlanDialog });
  };

  toggleConfirmOrderDialog = () => {
    this.setState({
      showConfirmOrderDialog: !this.state.showConfirmOrderDialog,
    });
  };

  toggleConfirmFollowCallDialog = () => {
    this.setState({
      showConfirmFollowCallDialog: !this.state.showConfirmFollowCallDialog,
    });
  };

  toggleLetterFileUploadDialog = () => {
    this.setState({
      showLetterFileUploadDialog: !this.state.showLetterFileUploadDialog,
    });
  };

  toggleLetterAdditionalFileUploadDialog = () => {
    this.setState({
      showLetterAdditionalFileUploadDialog: !this.state.showLetterAdditionalFileUploadDialog,
    });
  };

  toggleCalendar = (e) => {
    e && e.preventDefault();
    this.setState({ showCalendar: !this.state.showCalendar });
  };

  toggleOrderCalendar = (e) => {
    e && e.preventDefault();
    this.setState({ showOrderCalendar: !this.state.showOrderCalendar });
  };

  toggleInfoBox = () => {
    this.props.setShowSendLetterInfoBox(!this.props.showSendLetterInfoBox);
  };

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /******** handler functions *******/
  handleCheckQrCode = () => {
    this.setState({
      notUseQrCode: !this.state.notUseQrCode,
      tracking_url: this.state.notUseQrCode ? this.state.tracking_url : '',
    })
  }

  handleCheckShintenMark = (e) => {
    this.setState({
      shintenMarkFlag: e.target.checked,
    });
  };

  handleCheckRegisteredLetter = (e) => {
    this.setState({
      registeredLetterFlag: e.target.checked,
    });
  };

  handleChangeOriginalLetterFormat = (e) => {
    this.setState({
      originalLetterFormatFlag: e.target.value === 'original' ? true : false,
    });
  };

  handleChangeTrackingUrl = (e) => {
    this.setState({ tracking_url: e.target.value });
  };

  handleClickFollowCall = (flag) => {
    this.setState({
      followCallFlag: flag,
    })
  }

  handleOrder = () => {
    const { executiveListItem, addressItem, routerInfo, user } = this.props;
    const {
      to,
      from,
      file,
      additionalFile,
      usePastLetterOrderForAdditionalFile,
      usePastLetterOrderForFile,
      tracking_url,
      order_contact_id,
      shintenMarkFlag,
      followCallFlag,
      registeredLetterFlag,
      originalLetterFormatFlag,
      salesforce_sync_flag,
    } = this.state;
    const formData = new FormData();
    const isExe =
      routerInfo.state && routerInfo.state.hasOwnProperty("isExe")
        ? routerInfo.state.isExe
        : true;
    let id = null;
    let relocation_personnel_id;

    // #4183 前回の差出人、QRコードURLをブラウザに保存
    this.storeStateToLocalStorage();

    if (this.state.isMulti) {
      for (let key in this.props.routerInfo.state.query) {
        if (typeof this.props.routerInfo.state.query[key] === "object") {
          formData.append(
            key,
            JSON.stringify(this.props.routerInfo.state.query[key])
          );
        } else {
          formData.append(key, this.props.routerInfo.state.query[key]);
        }
      }
    } else {
      let address = {
        post_code: stripPostcode(to.post_code),
        company: to.company_name,
        branch: to.branch,
        position: to.honorific,
        name: to.name,
        address: to.address,
        honorific: to.suffix,
      };

      if (isExe) {
        address["executive_person_id"] = executiveListItem.executive_person_id;
        id = executiveListItem.executive_person_id;
        relocation_personnel_id = executiveListItem.id;
      } else {
        address["address_id"] = addressItem.id;
        id = addressItem.id;
      }

      const addresses = [address];

      formData.append("addresses", JSON.stringify(addresses));
    }

    let orderScheduledAt = this.state.orderScheduledAt.format(
      "YYYY-MM-DD HH:mm:ss"
    );
    let shippingScheduledAt = this.state.shippingScheduledAt.format(
      "YYYY-MM-DD HH:mm:ss"
    );
    let deliveryScheduledAt = moment(this.state.shippingScheduledAt)
      .add(1, "day")
      .format("YYYY-MM-DD HH:mm:ss");

    // 注文確認画面で0時を超えた場合、発送予定日が画面の表示では対応できなくなるので、注文させず、画面更新を促す。
    if (
      // 今日より注文予定日の日付が古い場合
      moment(orderScheduledAt).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD") ||
      // 今日から起算した、発送予定日より発送予定日の日付が古い場合
      moment(shippingScheduledAt).format("YYYY-MM-DD") < this.calcShippingScheduledDate({ orderScheduledAt: moment() }).format("YYYY-MM-DD")
    ) {
      alert("発送予定日が表示されている値では発送できなくなりました。恐れ入りますが、この画面を再読み込みしてください。");
      return;
    }

    formData.append("is_exe", isExe);
    formData.append("shinten_mark_flag", shintenMarkFlag);
    if (user && user.registered_letter_flag) {
      formData.append("registered_letter_flag", registeredLetterFlag);
    }
    if (user && user.original_letter_format_flag) {
      formData.append("original_letter_format_flag", originalLetterFormatFlag);
    }
    if (file) {
      formData.append("content_file", file);
    }
    if (additionalFile) {
      formData.append("additional_file", additionalFile);
    }
    if (usePastLetterOrderForFile) {
      formData.append("use_past_file_id", usePastLetterOrderForFile.id);
    }
    if (usePastLetterOrderForAdditionalFile) {
      formData.append("use_past_additional_file_id", usePastLetterOrderForAdditionalFile.id);
    }
    if ((isExe && isKLFollowCall(user)) || (!isExe && isEnableFollowCallHouseList(user))) {
      formData.append("follow_call_flag", followCallFlag ? 1 : 0);
    }
    formData.append("tracking_url", !this.state.notUseQrCode ? tracking_url : '');
    formData.append("order_scheduled_at", orderScheduledAt);
    formData.append("delivery_scheduled_at", deliveryScheduledAt);
    formData.append("shipping_scheduled_at", shippingScheduledAt);
    formData.append("order_contact_id", order_contact_id);
    formData.append("salesforce_sync_flag", salesforce_sync_flag ? 1 : 0);

    if (from && from.post_code) {
      formData.append("sender_post_code", stripPostcode(from.post_code));
    }
    if (from && from.company_name) {
      formData.append("sender_company", from.company_name);
    }
    if (from && from.branch) {
      formData.append("sender_branch", from.branch);
    }
    if (from && from.position) {
      formData.append("sender_position", from.position);
    }
    if (from && from.name) {
      formData.append("sender_name", from.name);
    }
    if (from && from.address) {
      formData.append("sender_address", from.address);
    }

    const param = {
      data: formData,
      id: id,
      isExe: isExe,
      orderScheduledAt: orderScheduledAt,
      shippingScheduledAt: shippingScheduledAt,
      relocation_personnel_id: relocation_personnel_id,
    }

    let exeDetailparam = {}
    // キーマンデータベース詳細ポップアップから遷移した場合
    if (this.props.routerInfo.state.hasOwnProperty("isExeDetail")) {
      exeDetailparam = {
        isExeDetail: true,
        query: this.props.routerInfo.state.query,
        filter: this.props.routerInfo.state.filter,
        item: this.props.routerInfo.state.item,
        filterValue: this.props.routerInfo.state.filterValue,
      }
    }

    this.props.postLetterOrdersOrder({
      ...param,
      ...exeDetailparam
    });
  };

  handleSelectSender = (sender) => {
    let from = {
      id: sender.id ? sender.id : "",
      post_code: sender.post_code ? sender.post_code : "",
      company_name: sender.company ? sender.company : "",
      address: sender.address ? sender.address : "",
      branch: sender.branch ? sender.branch : "",
      position: sender.position ? sender.position : "",
      name: sender.name ? sender.name : "",
    };
    this.setState({ from: from });
  };

  handleChangeOrderContact = (e) => {
    if (e.target.value === ADD_ORDER_CONTACT) {
      this.toggleCreateOrderContactDialog();
    } else {
      this.setState({
        order_contact_id: e.target.value,
      });
    }
  };

  handleToggleSalesforceSyncFlag = (value) => {
    this.setState({
      salesforce_sync_flag: value,
    });
  };

  disableButton = () => {
    const { user } = this.props;

    if (
      this.isFileUpload() &&
      Object.keys(validateSender(this.state.from)).length === 0 &&
      (this.state.isMulti ||
        Object.keys(validateAddressSendLetter(this.state.to)).length === 0) &&
      this.state.order_contact_id !== -1 &&
      this.state.order_contact_id !== ADD_ORDER_CONTACT
    ) {
      let letter_count = 0;
      let sent_count = user ? user.active_plan_letter_count : 0;
      let max_annual_letter_num =
        user.active_plan && user.active_plan.max_annual_letter_num
          ? user.active_plan.max_annual_letter_num
          : Infinity;

      if (this.state.isMulti) {
        letter_count = this.props.routerInfo.state.count;
      } else {
        letter_count = 1;
      }

      if (!this.state.notUseQrCode && !this.state.tracking_url) {
        return true;
      } else if (this.state.tracking_url && !isUrl(this.state.tracking_url)) {
        return true;
      } else if (this.state.tracking_url && this.state.tracking_url.length > MAX_TRACKING_URL_LENGTH) {
        return true;
      }

      if (letter_count + sent_count > max_annual_letter_num) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  };

  disableMessage = () => {
    const { user, classes } = this.props;
    let errors = [];

    if (
      !this.state.isMulti &&
      Object.keys(validateAddressSendLetter(this.state.to)).length > 0
    ) {
      errors.push(errMessages.ERR_MAILING_TO);
    }

    if (Object.keys(validateSender(this.state.from)).length > 0) {
      errors.push(errMessages.ERR_EMPTY_SENDER);
    }

    if (!this.isFileUpload()) {
      errors.push(errMessages.ERR_EMPTY_UPLOAD_FILE);
    }

    if (!this.state.notUseQrCode && !this.state.tracking_url) {
      errors.push(errMessages.ERR_EMPTY_TRACKING_URL);
    }

    if (this.state.tracking_url && !isUrl(this.state.tracking_url)) {
      errors.push(errMessages.ERR_BAD_FORMAT_TRACKING_URL);
    }

    if (this.state.tracking_url && this.state.tracking_url.length > MAX_TRACKING_URL_LENGTH) {
      errors.push(errMessages.ERR_MAX_TRACKING_URL_LENGTH);
    }

    if (
      this.state.order_contact_id === -1 ||
      this.state.order_contact_id === ADD_ORDER_CONTACT
    ) {
      errors.push(errMessages.ERR_EMPTY_ORDER_CONTACT);
    }

    let letter_count = 0;
    let sent_count = user ? user.active_plan_letter_count : 0;
    let max_annual_letter_num =
      user && user.active_plan && user.active_plan.max_annual_letter_num
        ? user.active_plan.max_annual_letter_num
        : Infinity;

    if (this.state.isMulti) {
      letter_count = this.props.routerInfo.state.count;
    } else {
      letter_count = 1;
    }

    if (letter_count + sent_count > max_annual_letter_num) {
      errors.push(errMessages.ERR_MAX_LETTER_NUM_REACHED);
    }

    if (errors.length > 0) {
      return errors.map((msg, i) => (
        <span key={i} className={classes.errorMessageRow}>
          <CancelCircle
            width={12}
            height={12}
            color="#F03A47"
            style={{ marginRight: "2px" }}
          />
          {msg}
        </span>
      ));
    } else {
      return "";
    }
  };

  changeUploadFIle =  async (file, pastLetterOrder) => {
    let wordContent = "";
    if (file) {
      this.setState({
        file: file,
      });
      try {
        wordContent = await getWordFileContent(file);
      } catch (error) {
        console.error('Wordファイルの内容取得でエラーが発生しました:', error); // eslint-disable-line no-console
      }
    } else {
      // 最近使用したファイルが選択された場合使用したletterOrderを保持する
      this.setState({
        usePastLetterOrderForFile: pastLetterOrder,
      });
      if (pastLetterOrder && pastLetterOrder.detail && pastLetterOrder.detail.content_text) {
        wordContent = pastLetterOrder.detail.content_text;
      }
    }

    if (wordContent !== "") {
      this.props.getLetterOrdersLetterContentCheck({ "word_content": wordContent, "to_name": this.state.isMulti ? null : this.state.to.name });
    }
  };

  changeUploadAdditionalFile = (additionalFile, pastLetterOrder) => {
    if (additionalFile) {
      this.setState({
        additionalFile: additionalFile,
      });
    } else {
      // 最近使用したファイルが選択された場合使用したletterOrderを保持する
      this.setState({
        usePastLetterOrderForAdditionalFile: pastLetterOrder,
      });
    }
  };

  isFileUpload = () => {
    return (this.state.file || this.state.usePastLetterOrderForFile)
  };

  goBack = () => {
    if (this.props.routerInfo.state.hasOwnProperty("isExeDetail")) {
      this.props.goTo(`/executive-list`, {
        query: this.props.routerInfo.state.query,
        filter: this.props.routerInfo.state.filter,
        item: this.props.routerInfo.state.item,
        filterValue: this.props.routerInfo.state.filterValue,
      });
    } else if (this.props.routerInfo.state.isExe) {
      this.props.goTo(`/executive-list`, {
        query: this.props.routerInfo.state.query,
        filter: this.props.routerInfo.state.filter,
      });
    } else {
      this.props.goTo(`/house-list`, this.props.routerInfo.state);
    }
  };

  calcShippingScheduledDate = (state = this.state) => {
    let orderScheduledAt = state.orderScheduledAt ? state.orderScheduledAt : this.state.orderScheduledAt;

    return addBusinessDays(
      orderScheduledAt.format("YYYY-MM-DD HH:mm:ss"), getAddBusinessDaysUntilShippingSchedule((this.props.routerInfo && this.props.routerInfo.state && this.props.routerInfo.state.count) ? this.props.routerInfo.state.count : 1)
    );
  };

  changeShippingScheduledDate = (date) => {
    this.setState({
      shippingScheduledAt: moment(date),
      showCalendar: false,
    });
  };

  changeOrderScheduledDate = (date) => {
    this.setState(
      {
        orderScheduledAt: moment(date),
        showOrderCalendar: false,
      },
      () => {
        this.setState({
          shippingScheduledAt: this.calcShippingScheduledDate(),
        });
      }
    );
  };

  populateStateFromLocalStorage = (props) => {
    const userId = props.user.id;
    const userRegisteredLetterFlag = props.user.registered_letter_flag;
    const userOriginalLetterFormatFlag = props.user.original_letter_format_flag;

    if (localStorage.hasOwnProperty(`sl-user${userId}-sender-id`)) {
      const lastSelectedSenderId = parseInt(
        localStorage.getItem(`sl-user${userId}-sender-id`),
        10
      );
      const sender = props.senders.find((s) => s.id === lastSelectedSenderId);

      if (sender) {
        this.handleSelectSender(sender);
      }
    }

    if (localStorage.hasOwnProperty(`sl-user${userId}-tracking-url`)) {
      const lastEnteredTrackingUrl = localStorage.getItem(
        `sl-user${userId}-tracking-url`
      );
      this.setState({ tracking_url: lastEnteredTrackingUrl });
    }

    if (localStorage.hasOwnProperty(`sl-user${userId}-shinten-mark-flag`)) {
      const lastEnteredShintenMarkFlag = parseInt(
        localStorage.getItem(`sl-user${userId}-shinten-mark-flag`),
        10
      );
      this.setState({ shintenMarkFlag: !!lastEnteredShintenMarkFlag });
    }

    if (localStorage.hasOwnProperty(`sl-user${userId}-registered-letter-flag`)) {
      const lastEnteredRegisteredLetterFlag = parseInt(
        localStorage.getItem(`sl-user${userId}-registered-letter-flag`),
        10
      );
      this.setState({ registeredLetterFlag: userRegisteredLetterFlag ? !!lastEnteredRegisteredLetterFlag : false });
    }

    if (localStorage.hasOwnProperty(`sl-user${userId}-original-letter-format-flag`)) {
      const lastEnteredOriginalLetterFormatFlag = parseInt(
        localStorage.getItem(`sl-user${userId}-original-letter-format-flag`),
        10
      );
      this.setState({ originalLetterFormatFlag: userOriginalLetterFormatFlag ? !!lastEnteredOriginalLetterFormatFlag : false });
    }
  };

  storeStateToLocalStorage = () => {
    const userId = this.props.user.id;
    const userRegisteredLetterFlag = this.props.user.registered_letter_flag;
    const userOriginalLetterFormatFlag = this.props.user.original_letter_format_flag;
    const { tracking_url, from, shintenMarkFlag, registeredLetterFlag, originalLetterFormatFlag } = this.state;

    //差出人ID
    if (from && from.id) {
      localStorage.setItem(`sl-user${userId}-sender-id`, from.id);
    }

    //QRコードURL
    if (tracking_url) {
      localStorage.setItem(`sl-user${userId}-tracking-url`, tracking_url);
    }

    //親展マーク
    localStorage.setItem(
      `sl-user${userId}-shinten-mark-flag`,
      shintenMarkFlag ? 1 : 0
    );

    //書留オプション
    localStorage.setItem(
      `sl-user${userId}-registered-letter-flag`,
      userRegisteredLetterFlag ? registeredLetterFlag ? 1 : 0 : 0
    );

    //レターフォーマット
    localStorage.setItem(
      `sl-user${userId}-original-letter-format-flag`,
      userOriginalLetterFormatFlag ? originalLetterFormatFlag ? 1 : 0 : 0
    );
  };

  /******** render functions *******/
  renderInfoDialog = () => (
    <InfoDialog
      isOpen={this.state.showInfoDialog}
      toggleDialog={this.toggleInfoDialog}
    />
  );

  renderSelectSenderDialog = () => (
    <SelectSenderDialog
      isOpen={this.state.showSelectSenderDialog}
      toggleDialog={this.toggleSelectSenderDialog}
      senders={this.props.senders}
      toggleEditSenderDialog={this.toggleEditSenderDialog}
      selectSender={this.handleSelectSender}
      selectedSenderId={this.state.from.id}
    />
  );

  renderEditSenderDialog = () => (
    <EditSenderDialog
      type={DialogType.CREATE}
      isOpen={this.state.showEditSenderDialog}
      toggleDialog={this.toggleEditSenderDialog}
      save={this.props.postSender}
      isSaving={this.props.isSavingSender}
      error={this.props.error}
    />
  );

  renderCreateOrderContactDialog = () => {
    if (this.state.showCreateOrderContactDialog) {
      return (
        <EditOrderContactDialog
          type={DialogType.CREATE}
          toggleDialog={this.toggleCreateOrderContactDialog}
          isOpen={this.state.showCreateOrderContactDialog}
          save={this.props.postOrderContacts}
          isSaving={this.props.isSavingOrderContact}
          error={this.props.error}
        />
      );
    }
  };

  renderEditRecipientDialog = () => (
    <EditRecipientDialog
      isOpen={this.state.showEditRecipientDialog}
      toggleDialog={this.toggleEditRecipientDialog}
      to={this.state.to}
      save={(value) => this.setState({ to: value })}
    />
  );

  renderPlanDialog = () => (
    <PlanDialog
      isOpen={this.state.showPlanDialog}
      toggleDialog={this.togglePlanDialog}
    />
  );

  renderConfirmOrderDialog = () => (
    <ConfirmOrderDialog
      isOpen={this.state.showConfirmOrderDialog}
      toggleDialog={this.toggleConfirmOrderDialog}
      letterCount={
        this.state.isMulti && this.props.routerInfo.state
          ? this.props.routerInfo.state.count
          : 1
      }
      trackingUrl={!this.state.notUseQrCode ? this.state.tracking_url : ''}
      user={this.props.user}
      isPosting={this.props.isPosting}
      handleOrder={this.handleOrder}
      disableButton={this.disableButton()}
      orderContact={this.props.orderContacts.filter(
        (c) => c.id === this.state.order_contact_id
      )}
      shippingScheduledAt={this.state.shippingScheduledAt}
      orderScheduledAt={this.state.orderScheduledAt}
      shintenMarkFlag={this.state.shintenMarkFlag}
      followCallFlag={this.state.followCallFlag}
      registeredLetterFlag={this.state.registeredLetterFlag}
      originalLetterFormatFlag={this.state.originalLetterFormatFlag}
      salesforce_sync_flag={this.state.salesforce_sync_flag}
      // 自社リストのフォローコール対応後に削除
      isExe={
        this.props.routerInfo.state.hasOwnProperty("isExe")
          ? this.props.routerInfo.state.isExe
          : true
      }
    />
  );

  renderConfirmFollowCallDialog = () => (
    <ConfirmFollowCallDialog
      isOpen={this.state.showConfirmFollowCallDialog}
      toggleDialog={this.toggleConfirmFollowCallDialog}
      handleClickFollowCall={this.handleClickFollowCall}
      order={this.toggleConfirmOrderDialog}
    />
  );

  renderLetterFileUploadDialog = () => (
    <LetterFileUploadDialog
      isOpen={this.state.showLetterFileUploadDialog}
      toggleDialog={this.toggleLetterFileUploadDialog}
      getLetterOrderList={this.props.getLetterOrderList}
      isLoading={this.props.isLoadingLetterOrderList}
      letterOrderList={this.props.letterOrderList}
      user={this.props.user}
      isAdditionalFile={false}
      UploadFile={this.props.getLetterOrderList}
      changeUploadFIle={this.changeUploadFIle}
      isMulti={this.state.isMulti}
      selectCount={this.state.selectCount}
    />
  );

  renderLetterAdditionalFileUploadDialog = () => (
    <LetterFileUploadDialog
      isOpen={this.state.showLetterAdditionalFileUploadDialog}
      toggleDialog={this.toggleLetterAdditionalFileUploadDialog}
      getLetterOrderList={this.props.getLetterOrderList}
      isLoading={this.props.isLoadingLetterOrderList}
      letterOrderList={this.props.letterOrderList}
      user={this.props.user}
      isAdditionalFile={true}
      UploadFile={this.props.getLetterOrderList}
      changeUploadFIle={this.changeUploadAdditionalFile}
      validateAdditionalFile={this.props.validateAdditionalFile}
    />
  );


  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderSimplifyAddressesText = () => {
    if (this.props.addressItem !== null && Object.keys(this.props.addressItem).length !== 0) {
      return formatName(this.props.addressItem);
    }

    if (this.props.executiveListItem !== null && Object.keys(this.props.executiveListItem).length !== 0) {
      return formatName(this.props.executiveListItem);
    }

    return "";
  }

  renderLeftCard = () => {
    const { classes } = this.props;
    const { to, from } = this.state;

    return (
      <div className={classes.card}>
        <img
          alt="send-letter-envelope-circle"
          src={require("../../assets/images/send-letter-envelope-circle.png")}
          className={classes.img}
        />

        <div className={classes.box}>
          <div className={classes.sectionHead} style={{ marginTop: 30 }}>宛名表記</div>
          {this.state.isMulti ? (
            <div>
              <Typography variant="body2" className={classes.leftCardText}>
                {this.renderSimplifyAddressesText()} 様　他{addCommas(this.state.selectCount - 1)}
                件の宛先
              </Typography>
              <Typography
                variant="body2"
                className={classes.leftCardText}
                style={{ color: "#71737B", marginTop: "5px" }}
              >
                一括送付の場合は宛名表記は編集できません
              </Typography>
            </div>
          ) : (
            <div>
              {(to.post_code || to.address) && (
                <Typography
                  variant="body2"
                  className={classes.leftCardText}
                >{`${to.post_code ? formatPostcode(to.post_code) + " " : ""}${to.address
                  }`}</Typography>
              )}
              {to.company_name && (
                <Typography
                  variant="body2"
                  className={classes.leftCardText}
                >{`${to.company_name}`}</Typography>
              )}
              {to.branch && (
                <Typography
                  variant="body2"
                  className={classes.leftCardText}
                >{`${to.branch}`}</Typography>
              )}
              {to.honorific && (
                <Typography
                  variant="body2"
                  className={classes.leftCardText}
                >{`${to.honorific}`}</Typography>
              )}
              {to.name && (
                <Typography
                  variant="body2"
                  className={classes.leftCardText}
                >{`${to.name} ${to.suffix}`}</Typography>
              )}
              <Button
                className={classNames(classes.btn, classes.btnGrey)}
                onClick={this.toggleEditRecipientDialog}
              >
                宛名表記を編集
              </Button>
            </div>
          )}
        </div>

        <div className={classes.box}>
          <div className={classes.sectionHead}>差出人表記</div>
          {(from.post_code || from.address) && (
            <Typography variant="body2" className={classes.leftCardText}>{`${from.post_code ? formatPostcode(from.post_code) : ""
              }${from.address}`}</Typography>
          )}
          {from.company_name && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${from.company_name}`}</Typography>
          )}
          {from.branch && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${from.branch}`}</Typography>
          )}
          {from.position && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${from.position}`}</Typography>
          )}
          {from.name && (
            <Typography
              variant="body2"
              className={classes.leftCardText}
            >{`${from.name}`}</Typography>
          )}
          <Button
            className={classNames(classes.btn, classes.btnBlue)}
            onClick={this.toggleSelectSenderDialog}
          >
            差出人表記を編集
          </Button>
        </div>

        <div className={classes.box}>
          <div className={classes.sectionHead}>親展マーク</div>
          <div className={classes.row} style={{ height: "30px" }}>
            <Typography variant="body2" className={classes.leftCardToggleText}>
              {this.state.shintenMarkFlag ? "あり" : "なし"}
            </Typography>

            <FormControlLabel
              control={
                <Switch
                  checked={this.state.shintenMarkFlag}
                  onChange={this.handleCheckShintenMark}
                  value="shintenMarkFlag"
                  color="primary"
                  classes={{
                    root: classes.switchBase,
                  }}
                />
              }
              className={classes.formControlLabel}
            />
          </div>
        </div>

        {!!this.props.user && !!this.props.user.registered_letter_flag && (
          <div className={classes.box}>
            <div className={classes.sectionHead}>書留サービス</div>
            <div className={classes.row} style={{ height: "30px" }}>
              <Typography variant="body2" className={classes.leftCardToggleText}>
                {this.state.registeredLetterFlag ? "利用する" : "利用しない"}
              </Typography>

              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.registeredLetterFlag}
                    onChange={this.handleCheckRegisteredLetter}
                    value="registeredLetterFlag"
                    color="primary"
                    classes={{
                      root: classes.switchBase,
                    }}
                  />
                }
                className={classes.formControlLabel}
              />
            </div>
          </div>
        )}

        {!!this.props.user && !!this.props.user.original_letter_format_flag && (
          <div className={classes.box}>
            <div className={classes.sectionHead}>レターフォーマット</div>
            <RadioGroup
              aria-label="gender"
              name="gender2"
              className={classes.group}
              value={this.state.originalLetterFormatFlag === false ? "kl" : "original"}
              onChange={this.handleChangeOriginalLetterFormat}
            >
              <FormControlLabel
                value="kl"
                style={{ height: 30 }}
                control={<Radio color="primary" />}
                label="キーマンレターのレターフォーマットを利用する"
                classes={{ label: classes.formControlLabel }} />
              <FormControlLabel
                value="original"
                style={{ height: 30 }}
                control={<Radio color="primary" />}
                label="別途納品したレターフォーマットを利用する"
                classes={{ label: classes.formControlLabel }} />
            </RadioGroup>
          </div>
        )}

        {!!this.props.user && !!this.props.user.can_select_order_scheduled_date && (
          <div className={classes.box}>
            <div className={classes.sectionHead}>
              <span style={{ fontSize: "inherit" }}>注文予定日</span>
              <ArrowToolTip text={"注文予定日を設定し、未来の注文を予約できます"}>
                <HelpIcon width={15} height={15} color="#71737B" />
              </ArrowToolTip>
            </div>
            <div className={classes.row}>
              <Typography variant="body2">
                {this.state.orderScheduledAt.format("YYYY年MM月DD日")}
              </Typography>
              <div style={{ position: "relative" }}>
                <Button
                  className={classNames(classes.btn, classes.btnBlue)}
                  onClick={this.toggleOrderCalendar}
                >
                  編集
                </Button>
                {this.state.showOrderCalendar && (
                  <div className={classes.datePicker}>
                    <DatePicker
                      id="date-picker"
                      locale="ja"
                      dateFormat={"yyyy/MM/dd"}
                      dateFormatCalendar={"yyyy年MM月"}
                      inline
                      selected={
                        new Date(this.state.orderScheduledAt.format("YYYY-MM-DD"))
                      }
                      onChange={this.changeOrderScheduledDate}
                      minDate={moment().toDate()}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {!!this.props.user && !!this.props.user.can_select_shipping_date && (
          <div className={classes.box}>
            <div className={classes.sectionHead}>
              <span style={{ fontSize: "inherit" }}>発送予定日</span>
              <ArrowToolTip text={"本日を含めて4営業日後から7営業日後目安に発送されます。注文宛先数が多い場合、10営業日かかる場合があります。到着予定日は発送予定日の1〜2営業日が目安です。"}>
                <HelpIcon width={15} height={15} color="#71737B" />
              </ArrowToolTip>
            </div>
            <div className={classes.row}>
              <Typography variant="body2">
                {this.state.shippingScheduledAt.format("YYYY年MM月DD日")}
              </Typography>
              <div style={{ position: "relative" }}>
                <Button
                  className={classNames(classes.btn, classes.btnBlue)}
                  onClick={this.toggleCalendar}
                >
                  編集
                </Button>
                {this.state.showCalendar && (
                  <div className={classes.datePicker}>
                    <DatePicker
                      id="date-picker"
                      locale="ja"
                      dateFormat={"yyyy/MM/dd"}
                      dateFormatCalendar={"yyyy年MM月"}
                      inline
                      selected={
                        new Date(
                          this.state.shippingScheduledAt.format("YYYY-MM-DD")
                        )
                      }
                      onChange={this.changeShippingScheduledDate}
                      excludeDates={HOLIDAYS_JP}
                      filterDate={isWeekday}
                      minDate={this.calcShippingScheduledDate().toDate()}
                      maxDate={this.calcShippingScheduledDate()
                        .add(1, "months")
                        .endOf("month")
                        .toDate()}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  renderRightCard = () => {
    const { classes } = this.props;
    return (
      <div className={classes.card} style={{ padding: "0px 0px 40px 0px" }}>
        <div
          className={classes.box}
          style={{ alignItems: "center", padding: "24px 48px 0px 48px" }}
        >
          <img
            alt="send-letter-upload-circle"
            src={
              this.isFileUpload() ?
                require("../../assets/images/send-letter-file-circle.png") :
                require("../../assets/images/send-letter-upload-circle.png")
            }
            className={classes.img}
          />
          <div className={classes.sectionRightHead}>
            レターデータをアップロード（.docx）
            <ArrowToolTip
              text={
                <div>
                  <span className={classes.linkBtn}>レター送付ガイド</span>
                  に沿って雛形から作成した.docx形式のファイルをアップロードしてください。
                  Wordの用紙サイズはA4に設定してください。
                </div>
              }
            >
              <HelpIcon
                width={15}
                height={15}
                color="#71737B"
                style={{ marginTop: "-2px", marginLeft: "2px" }}
              />
            </ArrowToolTip>
          </div>
          {(() => {
            if (!this.isFileUpload()) {
              return (
                <Button
                  color="primary"
                  onClick={this.toggleLetterFileUploadDialog}
                  className={classNames(classes.btn, classes.btnBlueSolid)}
                >
                  <Add color={"#1A65FF"} width={17} height={17} />
                  <span style={{ marginLeft: "5px" }}>追加または選択</span>
                </Button>
              )
            } else {
              let fileName = this.state.file ? this.state.file.name : this.state.usePastLetterOrderForFile.original_content_file_name;
              // 元のファイル名が保存されていない場合はcontent_pathのファイル名表示
              if (!fileName) {
                fileName = this.state.usePastLetterOrderForFile.content_path.split("/").pop();
              }
              return (
                <div className={classes.fileContainer}>
                  <div className={classes.fileType} style={{ fontSize: "24px" }}>W</div>
                  <div className={classes.fileInfo}>
                    <Typography
                      variant="subheading"
                      className={classes.filename}
                      title={fileName}
                    >
                      {fileName}
                    </Typography>
                    <Button
                      color="default"
                      onClick={() => {
                        this.setState({
                          file: null,
                          usePastLetterOrderForFile: null,
                        });
                      }}
                      className={classNames(classes.btn, classes.btnSelect)}
                    >
                      <Cancel width={16} height={16} />
                    </Button>
                  </div>
                </div>
              )
            }
          })()}
          <div className={classes.linkContainer}>
            <a
              href={'/how-to/send-letter/guide'}
              target="_blank"
              className={classes.link}
            >
              レター送付ガイド
            </a>
            <a
              href={'/how-to/send-letter'}
              target="_blank"
              className={classes.link}
            >
              レターテンプレート
            </a>
          </div>
          {this.renderQrCodeContainer()}
          {this.renderAdditionalFileUpload()}
        </div>
      </div>
    );
  };

  renderQrCodeContainer = () => {
    const { classes } = this.props;
    return (
      <div className={classes.qrCodeContainer}>
        <div className={classes.sectionRightHead}>
          <label>QRコードのURL入力</label>
          <ArrowToolTip text={"レターの中にQRコード画像を配置しており、かつQRコードの遷移先URLを設定すると、ターゲットのQRコード読み込みをリアルタイムで検知することができます。"}>
            <HelpIcon width={15} height={15} color="#71737B" />
          </ArrowToolTip>
        </div>
        <Input
          value={this.state.tracking_url}
          disableUnderline={true}
          disabled={this.state.notUseQrCode}
          placeholder="https://example.com"
          onChange={this.handleChangeTrackingUrl}
          fullWidth
        />
        <div className={classes.desc}>
          レターに挿入したQRコードの遷移先URLを入力してください。リアクションがあった際にお知らせいたします。
        </div>
        <div
          className={classes.checkboxContainer}
          onClick={this.handleCheckQrCode}
        >
          <Checkbox
            checked={this.state.notUseQrCode}
            onChange={this.handleCheckQrCode}
            color="primary"
            style={{
              width: "17px",
              height: "17px",
            }}
          />
          <Typography
            variant="subheading"
            style={{ marginLeft: "5px", fontSize: "12px" }}
          >
            QRコードを使用しない
          </Typography>
        </div>
      </div>
    )
  };

  /**
   * 添付物アップロードエリアの表示
   */
  renderAdditionalFileUpload = () => {
    const { classes, user } = this.props;
    if (!isEnableUploadAdditionalFile(user)) {
      return;
    }

    return (
      <React.Fragment>
        <div className={classes.sectionRightHead}>
          添付物をアップロード(任意)
          <ArrowToolTip
            text={
              <div>
                <span className={classes.linkBtn}>レター送付ガイド</span>
                に沿って縦A4サイズ 両面印刷1枚に収まるように2ページ以下の.pdf形式のファイルをアップロードしてください。カラー印刷が可能です。
              </div>
            }
          >
            <HelpIcon
              width={15}
              height={15}
              color="#71737B"
              style={{ marginTop: "-2px", marginLeft: "2px" }}
            />
          </ArrowToolTip>
        </div>
        {(() => {
          if (!this.state.additionalFile && !this.state.usePastLetterOrderForAdditionalFile) {
            return (
              <Button
                color="primary"
                onClick={this.toggleLetterAdditionalFileUploadDialog}
                className={classNames(classes.btn, classes.btnBlueSolid)}
              >
                <Add color={"#1A65FF"} width={17} height={17} />
                <span style={{ marginLeft: "5px" }}>追加または選択</span>
              </Button>
            );
          } else {
            let fileName = this.state.additionalFile ? this.state.additionalFile.name : this.state.usePastLetterOrderForAdditionalFile.original_additional_file_name;
            // 元のファイル名が保存されていない場合はadditional_file_pathのファイル名表示
            if (!fileName) {
              fileName = this.state.usePastLetterOrderForAdditionalFile.additional_file_path.split("/").pop();
            }
            return (
              <div className={classes.fileContainer}>
                <div className={classes.fileType} style={{ fontSize: "15px" }}>PDF</div>
                <div className={classes.fileInfo}>
                  <Typography
                    variant="subheading"
                    className={classes.filename}
                    title={fileName}
                  >
                    {fileName}
                  </Typography>
                  <Button
                    color="default"
                    onClick={() => {
                      this.setState({
                        additionalFile: null,
                        usePastLetterOrderForAdditionalFile: null
                      });
                    }}
                    className={classNames(classes.btn, classes.btnSelect)}
                  >
                    <Cancel width={16} height={16} />
                  </Button>
                </div>
              </div>
            );
          }
        })()}
      </React.Fragment>
    )
  };

  renderPlanNotification = () => {
    const { classes, user, routerInfo } = this.props;
    let text = "",
      buttonText = "";
    if (!user) {
      return;
    }

    if (isEnabledSendLetter(user) === false) {
      text = "レター送付機能をご利用いただくにはプランの変更が必要です";
      buttonText = "プランを変更する";
    } else {
      let sent_count = user ? user.active_plan_letter_count : 0;
      let max_annual_letter_num =
        user.active_plan && user.active_plan.max_annual_letter_num
          ? user.active_plan.max_annual_letter_num
          : Infinity;
      let letterCount =
        routerInfo.state && routerInfo.state.count
          ? routerInfo.state.count
          : 1;

      if (letterCount + sent_count > max_annual_letter_num) {
        text = "送付通数の上限に達しています";
        buttonText = "プランを変更する";
      }
    }

    if (text) {
      return (
        <div className={classes.notification}>
          {text}
          <span className={classes.linkBtn2} onClick={this.togglePlanDialog}>
            {buttonText}
          </span>
        </div>
      );
    }
  };

  renderInfoBox = () => (
    <InfoBox
      inOpen={this.state.showSendLetterInfoBox}
      toggleDialog={this.toggleInfoBox}
    />
  );

  render() {
    const { classes, user, routerInfo, orderContacts } = this.props;
    const isExe = !!routerInfo.state.isExe;

    let infoDialog,
      editSenderDialog,
      editRecipientDialog,
      planDialog,
      confirmOrderDialog,
      confirmFollowCallDialog,
      selectSenderDialog,
      letterFileUploadDialog,
      letterAdditionalFileUploadDialog,
      infoBox,
      notification;
    if (this.state.showInfoDialog) {
      infoDialog = this.renderInfoDialog();
    }
    if (this.state.showEditSenderDialog) {
      editSenderDialog = this.renderEditSenderDialog();
    }
    if (this.state.showEditRecipientDialog) {
      editRecipientDialog = this.renderEditRecipientDialog();
    }
    if (this.state.showPlanDialog) {
      planDialog = this.renderPlanDialog();
    }
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }
    if (this.state.showConfirmOrderDialog) {
      confirmOrderDialog = this.renderConfirmOrderDialog();
    }
    if (this.state.showConfirmFollowCallDialog) {
      confirmFollowCallDialog = this.renderConfirmFollowCallDialog();
    }
    if (this.state.showSelectSenderDialog) {
      selectSenderDialog = this.renderSelectSenderDialog();
    }
    if (this.state.showLetterFileUploadDialog) {
      letterFileUploadDialog = this.renderLetterFileUploadDialog();
    }
    if (this.state.showLetterAdditionalFileUploadDialog) {
      letterAdditionalFileUploadDialog = this.renderLetterAdditionalFileUploadDialog();
    }

    return (
      <Wrapper className={classes.root}>
        {this.renderPlanNotification()}
        <Header title="レター送付" type="dark" hasBackBtn={false} />

        {!this.state.isMulti &&
          ((isExe && this.props.executiveListItem === null) ||
            (!isExe &&
              JSON.stringify({}) === JSON.stringify(this.props.addressItem)) ||
            this.props.isLoadingItem) ? (
          <div className={classes.main}>
            <Loader type="color" size="large" />
          </div>
        ) : (
          <div className={classes.main}>
            <div className={classes.header}>
              <SendLetterHeader
                goBack={this.goBack}
                item={
                  isExe ? this.props.executiveListItem : this.props.addressItem
                }
                disableButton={this.disableButton()}
                disableMessage={this.disableMessage()}
                // TODO: 自社リストのフォローコール対応後に自社リストもフォローコールのダイアログを表示する
                // 自社運用プランはフォローコールのダイアログを表示しない
                order={((isExe && isKLFollowCall(user)) || (!isExe && isEnableFollowCallHouseList(user))) ? this.toggleConfirmFollowCallDialog : this.toggleConfirmOrderDialog}
                user={user}
                orderContacts={orderContacts}
                togglePlanDialog={this.togglePlanDialog}
                isMulti={this.state.isMulti}
                selectCount={this.state.selectCount}
                name={this.renderSimplifyAddressesText()}
                shippingScheduledAt={this.state.shippingScheduledAt}
                orderContactId={this.state.order_contact_id}
                handleChangeOrderContact={this.handleChangeOrderContact}
                letterCount={
                  this.state.isMulti && this.props.routerInfo.state
                    ? this.props.routerInfo.state.count
                    : 1
                }
                salesforce_sync_flag={this.state.salesforce_sync_flag}
                handleToggleSalesforceSyncFlag={
                  this.handleToggleSalesforceSyncFlag
                }
                address_import_mappings_flag={
                  this.props.address_import_mappings_flag
                }
                exe_export_mappings_flag={this.props.exe_export_mappings_flag}
                isExe={
                  this.props.routerInfo.state.hasOwnProperty("isExe")
                    ? this.props.routerInfo.state.isExe
                    : true
                }
              />
            </div>
            <div className={classes.content}>
              <div className={classes.cardContainer}>
                {this.renderLeftCard()}
                <Add
                  width={36}
                  height={36}
                  color="#B1B3B9"
                  style={{ margin: "auto 28px" }}
                />
                {this.renderRightCard()}
              </div>
            </div>
          </div>
        )}
        {infoDialog}
        {editSenderDialog}
        {editRecipientDialog}
        {planDialog}
        {confirmOrderDialog}
        {confirmFollowCallDialog}
        {notification}
        {selectSenderDialog}
        {letterFileUploadDialog}
        {letterAdditionalFileUploadDialog}
        {this.renderCreateOrderContactDialog()}
        {infoBox}
      </Wrapper>
    );
  }
}

SendLetter.propTypes = {
  classes: PropTypes.object.isRequired,
  cookies: instanceOf(Cookies).isRequired,
  showSendLetterInfoBox: PropTypes.bool,
  user: PropTypes.object,
  senders: PropTypes.array,
  isLoadingItem: PropTypes.bool,
  routerInfo: PropTypes.object,
  getExecutiveListById: PropTypes.func,
  getAddressById: PropTypes.func,
  goTo: PropTypes.func,
  getUserInfo: PropTypes.func,
  getSenders: PropTypes.func,
  getOrderContacts: PropTypes.func,
  getSalesforceConfig: PropTypes.func,
  executiveListItem: PropTypes.object,
  addressItem: PropTypes.object,
  sender: PropTypes.object,
  isLoadingOrderContacts: PropTypes.bool,
  orderContacts: PropTypes.array,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  orderContact: PropTypes.object,
  postOrderContacts: PropTypes.func,
  isSavingOrderContact: PropTypes.bool,
  isPosting: PropTypes.bool,
  postOrder: PropTypes.func,
  postSender: PropTypes.func,
  isSavingSender: PropTypes.bool,
  setShowSendLetterInfoBox: PropTypes.func,
  error: PropTypes.object,
  isLoadingLetterOrderList: PropTypes.bool,
  getLetterOrderList: PropTypes.func,
  letterOrderList: PropTypes.array,
  address_import_mappings_flag: PropTypes.bool,
  exe_export_mappings_flag: PropTypes.bool,
  postLetterOrdersOrder: PropTypes.func,
  getLetterOrdersLetterContentCheck: PropTypes.func,
  validateAdditionalFile: PropTypes.func,
  isCheckOK: PropTypes.bool,
  checkMessage: PropTypes.string,
};

export default withCookies(withStyles(styles)(SendLetter));



// WEBPACK FOOTER //
// ./src/components/SendLetter/SendLetter.jsx